import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { ProductComponent } from './product.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressSpinnerModule
  ],
  exports: [
    ProductComponent
  ],
  providers: [
  ],
  declarations: [
    ProductComponent
  ]
})
export class ProductModule { }
